"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _Link = _interopRequireDefault(require("@material-ui/core/Link"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ExpansionPanel = _interopRequireDefault(require("@material-ui/core/ExpansionPanel"));

var _ExpansionPanelSummary = _interopRequireDefault(require("@material-ui/core/ExpansionPanelSummary"));

var _ExpansionPanelDetails = _interopRequireDefault(require("@material-ui/core/ExpansionPanelDetails"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _icons = require("@material-ui/icons");

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _DocumentSelectorField = _interopRequireDefault(require("./DocumentSelectorField"));

var _reactRouterDom = require("react-router-dom");

var _classnames = _interopRequireDefault(require("classnames"));

var palette = _interopRequireWildcard(require("../../shared/oldDocumentSignerUI/palette"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var styles = function styles(theme) {
  return {
    emptyDocName: {
      color: palette.grey,
      fontStyle: 'italic'
    },
    statusText: {
      fontSize: 13,
      marginTop: 4
    },
    secondaryItemText: {
      padding: 0
    },
    incomplete: {
      color: palette.grey
    },
    success: {
      color: palette.success2
    },
    error: {
      color: theme.palette.error.main
    },
    docName: {
      fontSize: '1.2rem'
    },
    i9Instructions: {
      background: '#e3f1f6',
      padding: 8,
      margin: '6px 6px 2px 6px'
    },
    i9Link: {
      '&:hover': {
        cursor: 'pointer'
      },
      color: '#4eaffc',
      fontWeight: 'bold'
    },
    i9Text: {
      fontSize: 13
    },
    documentDetails: {
      padding: 0
    },
    documentSummary: {
      display: 'grid',
      gridTemplateColumns: '30px 1fr',
      columnGap: '12px',
      alignItems: 'center',
      wordBreak: 'break-all'
    },
    documentStatusMessage: {
      paddingLeft: 8
    },
    summaryExpanded: {
      boxShadow: '0 2px 2px rgba(209, 209, 209, 1)',
      zIndex: 2,
      borderLeft: '4px solid #5aaaa9 !important'
    },
    summaryRoot: {
      borderLeft: '4px solid white'
    },
    documentWarning: {
      color: '#FF7800',
      marginTop: 4
    },
    documentSuccess: {
      color: '#6DD400',
      marginTop: 4
    },
    fieldList: {
      width: '100%',
      backgroundColor: '#f4f8f7'
    }
  };
};

var DocumentSelectorPanel = function DocumentSelectorPanel(props) {
  var doc = props.doc,
      upstreamIsExpanded = props.isExpanded,
      setCurrentDocument = props.setCurrentDocument,
      classes = props.classes,
      onSelectAcknowledgment = props.onSelectAcknowledgment,
      _goToField = props.goToField;
  var id = doc.id,
      _doc$fields = doc.fields,
      fields = _doc$fields === void 0 ? [] : _doc$fields,
      _doc$categories = doc.categories,
      categories = _doc$categories === void 0 ? [] : _doc$categories,
      templateName = doc.templateName,
      acknowledge_type = doc.acknowledge_type,
      crew_acknowledged = doc.crew_acknowledged,
      _doc$_derived = doc._derived,
      wholeDocError = _doc$_derived.error,
      isComplete = _doc$_derived.isComplete,
      isViewable = _doc$_derived.isViewable;

  var _useState = (0, _react.useState)(upstreamIsExpanded),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  (0, _react.useEffect)(function () {
    setIsExpanded(upstreamIsExpanded);
  }, [upstreamIsExpanded]);
  var docNameClass = (0, _classnames.default)(classes.docName, _defineProperty({}, classes.emptyDocName, !isViewable));
  var acknowledgmentField = acknowledge_type === 'C' && {
    id: 'ACK',
    value: crew_acknowledged,
    _derived: {
      fieldType: 'ACK'
    }
  };
  var isFieldError = fields.some(function (_ref) {
    var error = _ref._derived.error;
    return error;
  });

  var documentStatusIcon = function () {
    if (wholeDocError || isFieldError) return /*#__PURE__*/_react.default.createElement(_icons.Error, {
      className: classes.error,
      "data-test-id": "DocumentSelector-documentStatusIcon-error-".concat(id)
    });
    if (isComplete) return /*#__PURE__*/_react.default.createElement(_icons.CheckCircle, {
      className: classes.success,
      "data-test-id": "DocumentSelector-documentStatusIcon-".concat(id)
    });
    return /*#__PURE__*/_react.default.createElement(_icons.CheckCircle, {
      className: classes.incomplete,
      "data-test-id": "DocumentSelector-documentStatusIcon-".concat(id)
    });
  }();

  var filteredFields = fields.filter(function (_ref2) {
    var _ref2$_derived = _ref2._derived,
        error = _ref2$_derived.error,
        isRequired = _ref2$_derived.isRequired;
    return error || isRequired;
  });

  var i9Instructions = categories.some(function (_ref3) {
    var _ref3$name = _ref3.name,
        name = _ref3$name === void 0 ? '' : _ref3$name;
    return name.toLowerCase().includes('i9') || name.toLowerCase().includes('i-9');
  }) && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.i9Instructions,
    "data-test-id": "DocumentSelector-i9Instructions"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.i9Text,
    "data-test-id": "DocumentSelector-i9InstructionsText"
  }, "Need help? View", ' ', /*#__PURE__*/_react.default.createElement(_Link.default, {
    className: classes.i9Link,
    to: '/samples/i-9instr.pdf',
    "data-test-id": "DocumentSelector-i9InstructionsLink",
    component: _reactRouterDom.Link,
    target: "_blank"
  }, "I-9 Instructions"), ' ', "on how to fill out this form."));

  var documentStatusMessage = function () {
    var _classNames2;

    var message = 'Form is not complete';

    if (wholeDocError) {
      if (wholeDocError.message) {
        message = wholeDocError.message;
      } else {
        message = 'There was an error saving this form';
      }
    }

    if (isComplete) message = 'Form is complete';
    if (isFieldError) message = 'This form was completed with errors';
    return /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: (0, _classnames.default)(classes.documentStatusMessage, (_classNames2 = {}, _defineProperty(_classNames2, classes.documentWarning, !isComplete || isFieldError), _defineProperty(_classNames2, classes.documentSuccess, isComplete), _classNames2)),
      "data-test-id": "DocumentSelector-statusMessage"
    }, message);
  }();

  return /*#__PURE__*/_react.default.createElement(_ExpansionPanel.default, {
    key: id,
    "data-test-id": "DocumentSelector-document-".concat(id),
    expanded: isExpanded
  }, /*#__PURE__*/_react.default.createElement(_ExpansionPanelSummary.default, {
    onClick: function onClick() {
      setCurrentDocument(id);
      setIsExpanded(!isExpanded);
    },
    disabled: !isViewable,
    classes: {
      content: classes.documentSummary,
      root: (0, _classnames.default)(classes.summaryRoot, _defineProperty({}, classes.summaryExpanded, isExpanded))
    },
    expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null),
    "data-test-id": "DocumentSelectorPanel-panelSummary-".concat(id)
  }, documentStatusIcon, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: docNameClass,
    "data-test-id": "DocumentSelector-docName-".concat(id)
  }, templateName)), /*#__PURE__*/_react.default.createElement(_ExpansionPanelDetails.default, {
    classes: {
      root: classes.documentDetails
    }
  }, /*#__PURE__*/_react.default.createElement(_core.List, {
    component: "div",
    disablePadding: true,
    className: classes.fieldList
  }, /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
    secondary: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, i9Instructions, documentStatusMessage),
    classes: {
      secondary: classes.statusText,
      root: classes.secondaryItemText
    },
    "data-test-id": "DocumentSelector-documentStatusText-".concat(id)
  }), acknowledgmentField && /*#__PURE__*/_react.default.createElement(_DocumentSelectorField.default, {
    field: acknowledgmentField,
    goToField: onSelectAcknowledgment
  }), filteredFields.map(function (field) {
    return /*#__PURE__*/_react.default.createElement(_DocumentSelectorField.default, {
      field: field,
      goToField: function goToField() {
        return _goToField(field.id);
      },
      key: field.id
    });
  }))));
};

var _default = (0, _styles.withStyles)(styles)(DocumentSelectorPanel);

exports.default = _default;